import { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

const formatNumber = (value) => parseFloat(value || 0).toLocaleString(navigator.language, { minimumFractionDigits: 3 });

const EmissionsDisaggregatedByOrganisationRow = ({ facility, orgID, facilityData, organisations, adminOrgs }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const toggleRow = (id) => {
    setExpandedRows((prevExpandedRows) => {
      const newExpandedRows = new Set(prevExpandedRows);
      if (newExpandedRows.has(id)) {
        newExpandedRows.delete(id);
      } else {
        newExpandedRows.add(id);
      }
      return newExpandedRows;
    });
  };
  return (
    <tr>
      <td className='w-1/5 text-left'>
        {orgID === 'all' ? 'Total' : adminOrgs && adminOrgs?.find((item) => item.id == orgID)?.name}
      </td>
      <td className='w-1/5'>
        <div className='hidden sm:block text-right'>
          <span className='toggle-location'>
            {formatNumber(
              organisations[orgID] && organisations[orgID].co2e ? organisations[orgID].co2e.toFixed(3) : '0.000',
            )}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              organisations[orgID] && organisations[orgID].marketScope
                ? _.sum(Object.values(organisations[orgID].marketScope))
                : 0,
            )}
          </span>
        </div>
        <div className='flex sm:hidden flex-col justify-end'>
          <span className='toggle-location'>
            {formatNumber(
              organisations[orgID] && organisations[orgID].co2e ? organisations[orgID].co2e.toFixed(3) : '0.000',
            )}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              organisations[orgID] && organisations[orgID].marketScope
                ? _.sum(Object.values(organisations[orgID].marketScope))
                : 0,
            )}
          </span>
          <button className='text-xs text-primary underline mt-1 text-right' onClick={() => toggleRow(orgID)}>
            {expandedRows.has(orgID) ? 'Hide Details' : 'View Details'}
          </button>
          {expandedRows.has(orgID) && (
            <div className='usage-detail normal-case text-muted-foreground'>
              <span className='toggle-location'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].scope[1]
                      ? organisations[orgID].scope[1].toFixed(3)
                      : '0.000',
                  )}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].scope[2]
                      ? organisations[orgID].scope[2].toFixed(3)
                      : '0.000',
                  )}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].scope[3]
                      ? organisations[orgID].scope[3].toFixed(3)
                      : '0.000',
                  )}
                </p>
              </span>
              <span className='toggle-market'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].marketScope[1]
                      ? organisations[orgID].marketScope[1].toFixed(3)
                      : organisations[orgID] && organisations[orgID].scope[1]
                        ? organisations[orgID].scope[1].toFixed(3)
                        : '0.000',
                  )}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].marketScope[2]
                      ? organisations[orgID].marketScope[2].toFixed(3)
                      : '0.000',
                  )}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(
                    organisations[orgID] && organisations[orgID].marketScope[3]
                      ? organisations[orgID].marketScope[3].toFixed(3)
                      : '0.000',
                  )}
                </p>
              </span>
            </div>
          )}
        </div>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].scope[1] ? organisations[orgID].scope[1].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].marketScope[1]
              ? organisations[orgID].marketScope[1].toFixed(3)
              : organisations[orgID] && organisations[orgID].scope[1]
                ? organisations[orgID].scope[1].toFixed(3)
                : '0.000',
          )}
        </span>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].scope[2] ? organisations[orgID].scope[2].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].marketScope[2]
              ? organisations[orgID].marketScope[2].toFixed(3)
              : '0.000',
          )}
        </span>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].scope[3] ? organisations[orgID].scope[3].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            organisations[orgID] && organisations[orgID].marketScope[3]
              ? organisations[orgID].marketScope[3].toFixed(3)
              : '0.000',
          )}
        </span>
      </td>
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { emissionsByFacility } = state.consumption;
  const adminOrgs = state.admin?.organisations;
  const organisationList = state.organisation?.list;
  const { cyfAdmin, whiteLabelAdmin } = state.profile?.details || {};
  const adminUser = cyfAdmin || whiteLabelAdmin || false;

  const { facilityID } = ownProps;

  const facilityData =
    state.report &&
    state.report.details &&
    state.report.details.year &&
    emissionsByFacility[state.report.details.year] &&
    emissionsByFacility[state.report.details.year][facilityID];
  const facility =
    emissionsByFacility &&
    state?.facility?.hierarchyFacilities &&
    _.uniqBy(state.facility?.hierarchyFacilities, 'id')?.find((item) => item.id == facilityID);

  return {
    facilityData,
    facility,
    adminOrgs: adminUser ? adminOrgs : organisationList,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsDisaggregatedByOrganisationRow);
